import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { RequestStatusDisplay } from '../CommonComponents';
import { Anchor } from "../RequestRespectingInputs";
import { RequestStatus } from '../../api_request/api_request';
import { useState } from 'react';
import { sendLogout } from './data';

export function LogoutLink()
{
    const appDispatch = useAppDispatch();
    const loggedInUserName = useAppSelector((state) => state.login.currentUser?.username);
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);
    
    const logoutLink =
    <span>
        <Anchor to='/' onClick={
                async function(e)
                {
                    if (!window.confirm('Confirm logout?'))
                    {
                        e.preventDefault();
                        return;
                    }

                    sendLogout(appDispatch, setRequest);
                }}>
            Log Out
        </Anchor>
        <RequestStatusDisplay request={request}/>
    </span>;

    if (loggedInUserName)
    {
        return <>Welcome, <Anchor to={`user/settings`}>{loggedInUserName}</Anchor>! {logoutLink}</>
    }

    return null;
}